module.exports = __webpack_public_path__ + "img/p4.d90280ea.png";